import {useReportUserVisibleError} from '@github-ui/copilot-browser-latency/use-report-user-visible-error'
import {INCREASE_INDIVIDUAL_BUDGET_URL} from '@github-ui/copilot-chat-helpers/copilot-chat-helpers'
import {EntitlementQuotaBanner} from '@github-ui/copilot-shared-ui/components/EntitlementQuotaBanner'
import {useEntitlementQuotaNotice} from '@github-ui/copilot-shared-ui/hooks/use-entitlement-quota-notice'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useEffect, useRef} from 'react'
import type {AgentQuotaSnapshot} from '@github-ui/agent-sessions-types/agent-quota-snapshot'
import styles from './QuotaBanner.module.css'

type QuotaBannerProps = {
  agentQuotaSnapshot?: AgentQuotaSnapshot | null
}

const INDIVIDUAL_EXHAUSTED_ANALYTICS_CONTEXT = {
  category: 'general_ipm_ubb_user_exhausted_alerts_individual',
  scope: 'personal',
} as const
const INDIVIDUAL_BUDGET_SURFACE = 'agent_sessions_quota_banner'

export function QuotaBanner({agentQuotaSnapshot}: QuotaBannerProps) {
  const {notice} = useEntitlementQuotaNotice({kind: 'agent', snapshot: agentQuotaSnapshot})
  const useIndividualBudgetCta = notice?.primaryAction?.href === INCREASE_INDIVIDUAL_BUDGET_URL
  const sentShownRef = useRef(false)

  useEffect(() => {
    if (!useIndividualBudgetCta || sentShownRef.current) return

    sentShownRef.current = true
    sendEvent('dotcom_chat.activate', {
      target: 'QUOTA_BANNER_EXCEEDED',
      action: 'shown',
      category: INDIVIDUAL_EXHAUSTED_ANALYTICS_CONTEXT.category,
      scope: INDIVIDUAL_EXHAUSTED_ANALYTICS_CONTEXT.scope,
      surface: INDIVIDUAL_BUDGET_SURFACE,
    })
  }, [useIndividualBudgetCta])

  useReportUserVisibleError(notice?.variant === 'critical' ? 'quota_exhausted' : undefined)

  if (!notice) return null

  return (
    <EntitlementQuotaBanner
      notice={notice}
      className={styles.container}
      onPrimaryAction={
        useIndividualBudgetCta
          ? () =>
              sendEvent('dotcom_chat.activate', {
                target: 'QUOTA_BANNER_EXCEEDED',
                action: 'increase_budget',
                category: INDIVIDUAL_EXHAUSTED_ANALYTICS_CONTEXT.category,
                scope: INDIVIDUAL_EXHAUSTED_ANALYTICS_CONTEXT.scope,
                surface: INDIVIDUAL_BUDGET_SURFACE,
              })
          : undefined
      }
    />
  )
}
